/**
 * A helper function for comparing values to sort them in an array.
 * Use it like:
 *   array.sort(compareTwoValues)
 * @param {Number|String|Array} a First value to compare
 * @param {Number|String|Array} b Second vale to compare
 * @return {Number} The sorted numbers
 */
export function compareTwoValues(a, b) {
    function isNumber(x) {
        const value = parseInt(x, 10)
        return !!(value || value === 0)
    }

    const comparableA = a || 0
    const comparableB = b || 0

    if (isNumber(comparableA) && isNumber(comparableB)) {
        let aNumber = comparableA
        let bNumber = comparableB
        if (comparableA.length === 1) {
            aNumber = comparableA.toString().padStart(3, '0')
        }
        if (comparableB.length === 1) {
            bNumber = comparableB.toString().padStart(3, '0')
        }
        if (aNumber < bNumber) return -1
        if (aNumber > bNumber) return 1
    } else if (typeof comparableA.toLowerCase === 'function' && typeof comparableB.toLowerCase === 'function') {
        return comparableA.toLowerCase().localeCompare(comparableB.toLowerCase())
    } else if (typeof comparableA.localeCompare === 'function') {
        return comparableA.localeCompare(comparableB)
    } else {
        if (String(comparableA) < String(comparableB)) return -1
        if (String(comparableA) > String(comparableB)) return 1
    }
    return 0
}
